import { SET_MENU_OPTIONS } from './constants';

export const setMenuOptions = payload => dispatch => {
  dispatch({
    type: SET_MENU_OPTIONS,
    payload,
  });
};
